<template>
  <button class="transparent-button" @click="emitClick">
    <span class="transparent-button__icon" v-html="icon" v-if="icon"></span>
    {{ text }}
  </button>
</template>

<script>
export default {
  name: "TransparentButton",
  props: {
    text: String,
    icon: {
      type: String,
      default: null,
    },
  },
  methods: {
    emitClick() {
      this.$emit("click");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/_variables.scss";
@import "~@/assets/scss/_mixins.scss";

.transparent-button {
  padding: 17px 30px;
  background: transparent;
  border-radius: 6px;
  color: $action;
  font-size: pxToRem(16);
  line-height: pxToRem(19);
  font-weight: 600;
  transition: opacity 0.2s linear, background-color 0.2s linear;
  border: none;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
    background-color: #f7fcff;
  }
}
</style>
